import { useEditorRef, withRef } from '@udecode/plate/react';
import { useCallback } from 'react';

import { ToolbarButton } from '../common/toolbar.component';

export const InsertToolbarButton = withRef<
    typeof ToolbarButton,
    {
        insertText: string;
    }
>((props, ref) => {
    const editor = useEditorRef();

    const onClick = useCallback(() => {
        editor.tf.insertText(props.insertText);
    }, [ editor ]);

    return (
        <ToolbarButton
            ref={ref}
            onClick={onClick}
            tooltip={'Vložit znak ' + props.insertText}
            {...props}
        />
    );
});
